module.exports = __webpack_public_path__ + "media/src/images/icons/credit_cards/american-740e53c2f24ad898a583eb1e7c961243.gif";